import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../firebase/firebaseConfig";
import Header from "../../components/header/Header.jsx";
import Footer from "../../components/footer/Footer.jsx";
import Scrollbar from '../../components/scrollbar/scrollbar'

const ProposalRequest = () => {
  const [forms, setForms] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    associationName: "",
    totalHomes: "",
    communityType: "",
    professionallyManaged: "",
    contractExpiration: "",
    serviceType: "",
    boardPosition: "",
    communityDescription: "",
    reserveStudyDate: "",
    boardMeetingFrequency: "",
    assessmentBillingFrequency: "",
    litigation: "",
    constructionProjects: ""
  });

  const [, forceUpdate] = useState();
  const validator = new SimpleReactValidator({
    className: "errorMessage",
    autoForceUpdate: { forceUpdate: () => forceUpdate({}) },
  });

  const changeHandler = (e) => {
    setForms((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    validator.showMessageFor(e.target.name);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }

    try {
      const functions = getFunctions(app);
      const sendContactEmail = httpsCallable(functions, "sendContactEmail");

      const dataToSend = { ...forms };
      console.log("FINAL DATA SENT TO FIREBASE:", dataToSend);

      await sendContactEmail(dataToSend);

      // RESET FORM
      setForms({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        associationName: "",
        totalHomes: "",
        communityType: "",
        professionallyManaged: "",
        contractExpiration: "",
        serviceType: "",
        boardPosition: "",
        communityDescription: "",
        reserveStudyDate: "",
        boardMeetingFrequency: "",
        assessmentBillingFrequency: "",
        litigation: "",
        constructionProjects: "",
      });

      alert("Proposal request sent successfully!");
    } catch (error) {
      console.error("Error sending proposal request:", error);
      alert("There was an error sending your proposal request.");
    }
  };

  return (
    <>

    {/* === SCROLL TARGET FOR BACK-TO-TOP BUTTON === */}
    <div id="scrool"></div>

    <Header />

    <section className="contact-wrapper">
      <div className="container contact-form-block contact-form-modern">
        <h2 className="contact-form-title">Proposal Request</h2>

        <form onSubmit={submitHandler}>
          {/* FIRST & LAST NAME */}
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="firstName"
                  value={forms.firstName || ""}
                  onChange={changeHandler}
                  required
                />
                <label>First Name</label>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="lastName"
                  value={forms.lastName || ""}
                  onChange={changeHandler}
                  required
                />
                <label>Last Name</label>
              </div>
            </div>
          </div>

          {/* EMAIL & PHONE */}
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="email"
                  name="email"
                  value={forms.email || ""}
                  onChange={changeHandler}
                  required
                />
                <label>Email Address</label>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="tel"
                  name="phone"
                  value={forms.phone || ""}
                  onChange={changeHandler}
                  required
                />
                <label>Phone Number</label>
              </div>
            </div>
          </div>

          {/* ASSOCIATION NAME */}
          <div className="form-floating-field">
            <input
              type="text"
              name="associationName"
              value={forms.associationName || ""}
              onChange={changeHandler}
              required
            />
            <label>Association Legal Name & Address</label>
          </div>

          {/* TOTAL HOMES + COMMUNITY TYPE */}
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="totalHomes"
                  value={forms.totalHomes || ""}
                  onChange={changeHandler}
                  required
                />
                <label>Total Number of Homes</label>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="communityType"
                  value={forms.communityType || ""}
                  onChange={changeHandler}
                />
                <label>Community Type (SF, TH, Condo, Etc.)</label>
              </div>
            </div>
          </div>

          {/* PROFESSIONALLY MANAGED */}
          <div className="form-floating-field">
            <select
              name="professionallyManaged"
              value={forms.professionallyManaged || ""}
              onChange={changeHandler}
            >
              <option value="">Select...</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <label>Is the association professionally managed?</label>
          </div>

          {/* CONTRACT EXPIRATION */}
          <div className="form-floating-field">
            <input
              type="date"
              name="contractExpiration"
              value={forms.contractExpiration || ""}
              onChange={changeHandler}
            />
            <label>Expiration date of current contract</label>
          </div>

          {/* SERVICE TYPE */}
          <div className="form-floating-field">
            <select
              name="serviceType"
              value={forms.serviceType || ""}
              onChange={changeHandler}
              required
            >
              <option value="">Select...</option>
              <option value="Full Service">Full Service</option>
              <option value="Financial Management Services">
                Financial Management Services
              </option>
            </select>
            <label>Management Services Desired</label>
          </div>

          {/* BOARD POSITION */}
          <div className="form-floating-field">
            <input
              type="text"
              name="boardPosition"
              value={forms.boardPosition || ""}
              onChange={changeHandler}
            />
            <label>If you are a Board Member, indicate your position</label>
          </div>

          {/* DESCRIPTION */}
          <div className="form-floating-field">
            <textarea
              name="communityDescription"
              value={forms.communityDescription || ""}
              onChange={changeHandler}
            ></textarea>
            <label>Describe your community here</label>
          </div>

          {/* RESERVE STUDY */}
          <div className="form-floating-field">
            <input
              type="text"
              name="reserveStudyDate"
              value={forms.reserveStudyDate || ""}
              onChange={changeHandler}
            />
            <label>Date of last reserve study</label>
          </div>

          {/* MEETING FREQUENCY */}
          <div className="form-floating-field">
            <select
              name="boardMeetingFrequency"
              value={forms.boardMeetingFrequency || ""}
              onChange={changeHandler}
            >
              <option value="">Select...</option>
              <option value="Monthly">Monthly</option>
              <option value="Quarterly">Quarterly (every 3 months)</option>
              <option value="Semi-Annually">Semi-Annually (twice a year)</option>
              <option value="Annually">Annually (once a year)</option>
            </select>
            <label>Frequency of Board Meetings</label>
          </div>

          {/* ASSESSMENT BILLING */}
          <div className="form-floating-field">
            <select
              name="assessmentBillingFrequency"
              value={forms.assessmentBillingFrequency || ""}
              onChange={changeHandler}
            >
              <option value="">Select...</option>
              <option value="Monthly">Monthly</option>
              <option value="Quarterly">Quarterly (every 3 months)</option>
              <option value="Semi-Annually">Semi-Annually (twice a year)</option>
              <option value="Annually">Annually (once a year)</option>
            </select>
            <label>Frequency of assessment billing</label>
          </div>

          {/* LITIGATION */}
          <div className="form-floating-field">
            <input
              type="text"
              name="litigation"
              value={forms.litigation || ""}
              onChange={changeHandler}
            />
            <label>Current litigation, if any</label>
          </div>

          {/* CONSTRUCTION PROJECTS */}
          <div className="form-floating-field">
            <input
              type="text"
              name="constructionProjects"
              value={forms.constructionProjects || ""}
              onChange={changeHandler}
            />
            <label>Current or pending construction projects</label>
          </div>

          {/* SUBMIT BUTTON */}
          <button
            type="submit"
            className="primary-btn"
            style={{ marginTop: "20px" }}
          >
            Submit Proposal Request
          </button>
        </form>
      </div>
    </section>

    {/* FOOTER */}
    <Footer />

{/* BACK TO TOP BUTTON */}
<Scrollbar />

</>
  );
};

export default ProposalRequest;
